import { PropsWithChildren, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { PageProps } from 'gatsby';
import { languageAtom } from 'atoms/language';
import { useSiteMetadata } from 'hooks/useSiteMetadata';
import { SupportedLanguages } from 'models/languages';

const PageRoot = ({
  children,
  pageContext,
}: PropsWithChildren<Omit<PageProps<unknown, { lang: SupportedLanguages }>, 'children'>>) => {
  const { defaultLanguage } = useSiteMetadata();
  const [, setLanguage] = useRecoilState(languageAtom);

  useEffect(() => {
    setLanguage(pageContext.lang ?? defaultLanguage);
  }, [pageContext.lang, defaultLanguage]);

  return children;
};

export default PageRoot;
